import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-scroll';
// import { nanoid } from 'nanoid';
import GithubButtons from '../GithubButtons/GithubButtons';
import { DEFAULT_DURATION } from '../../common/constants';

const isEnabledButtonsGithub = false;
// const networks = [
//   {
//     id: nanoid(),
//     name: 'linkedin',
//     url: 'https://www.linkedin.com/in/artsiom-marozau/',
//   },
//   {
//     id: nanoid(),
//     name: 'github',
//     url: 'https://github.com/MarozauArtsiom',
//   },
//   {
//     id: nanoid(),
//     name: 'linkedin',
//     url: 'https://www.linkedin.com/in/denis-levshukov-153a001b6/',
//   },
//   {
//     id: nanoid(),
//     name: 'github',
//     url: 'https://github.com/DrJekill352',
//   },
// ];

const Footer = () => {
  return (
    <footer className="footer navbar-static-bottom">
      <Container>
        <span className="back-to-top">
          <Link to="hero" smooth duration={DEFAULT_DURATION}>
            <i className="fa fa-angle-up fa-2x" aria-hidden="true" />
          </Link>
        </span>
        {/* <div className="social-links">
          {networks &&
            networks.map((network) => {
              const { id, name, url } = network;
              return (
                <a key={id} href={url} rel="noopener noreferrer" target="_blank" aria-label={name}>
                  <i className={`fa fa-${name || 'refresh'} fa-inverse`} />
                </a>
              );
            })}
        </div> */}
        {/* <hr /> */}
        <p className="footer__text">© {new Date().getFullYear()} - SWEG</p>
        {isEnabledButtonsGithub && <GithubButtons />}
      </Container>
    </footer>
  );
};

export default Footer;
